module.exports = __webpack_public_path__ + "static/media/U volume.f0e78a48.jpg";